import { Component } from 'react';
import PropTypes from 'prop-types';

export default class AppContext extends Component {
  static get propTypes() {
    return {
      app: PropTypes.object.isRequired,
      children: PropTypes.array.isRequired,
    };
  }

  static get childContextTypes() {
    return {
      app: PropTypes.any,
    };
  }

  getChildContext() {
    return {
      app: this.props.app,
    };
  }

  render() {
    return this.props.children;
  }
}



// WEBPACK FOOTER //
// ./src/components/core/AppContext.js